import { Icon, Headline2, Body2 } from "@bms-ai/bms-ai-ui-lib/components";

export default function Forbidden() {
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            color: "#BE2BBB"
        }}>
            <Icon type="question" size="large" />
            <Headline2
                className="font-bms font-bold"
                style={{
                    marginTop: "1rem",
                    fontSize: "2.5rem"
                }}
            >
                Access Restricted
            </Headline2>
            <Body2
                className="font-bms font-normal"
                style={{
                    marginTop: "0.5rem",
                    fontSize: "1.2rem",
                    color: "#444"
                }}
            >
                You do not have permission to access this page.
            </Body2>
        </div>
    );
}